import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const autoAcknowledgementFieldsStyles = StyleSheet.create({
	nested: {
		marginTop: THEME.spacing.md,
		paddingLeft: THEME.spacing.lg,
	},
	// Matches the sibling toggles on this page: centred on the title rather than the wrapped block.
	settingRow: {
		alignItems: 'flex-start' as const,
		padding: '6px 0',
	},
	settingTitle: {
		lineHeight: '22px',
	},
	warning: {
		marginTop: THEME.spacing.sm,
		padding: THEME.spacing.sm,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: THEME.colors.warning.light,
		borderLeft: `3px solid ${THEME.colors.warning.main}`,
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.xs,
	},
});
